// extracted by mini-css-extract-plugin
module.exports = {"FullWidth":"Search_FullWidth__2hX0y","FormLabel":"Search_FormLabel__3G8j1"};